import {observer} from 'mobx-react-lite'
import './../Parent/parent.css'
import {useLocation} from 'react-router-dom'
import {useEffect} from 'react'
import clubStore from '../../../storage/ClubStore'
import PageLayout from '../../PageLayout'
import appStore from '../../../storage/AppStore'
import AttendanceItem from '../ParentMember/AttendanceItem'

const MemberAttendance = () => {
  const location = useLocation();
  
  useEffect(() => {
    clubStore.child.getChild().then(() => {
      clubStore.child.getAttendance()
    })
  }, [location.pathname])
  
  return (
    <PageLayout header={
      <div className="flex justify-content-between align-items-center">
        <h3 className="m-0">{appStore.tr.attendance}</h3>
      </div>
    }>
      <div className="grid">
        {clubStore.child.attendance.map((period, idx) => (
          <AttendanceItem period={period} key={idx}/>
        ))}
      </div>
    </PageLayout>
  );
}

export default observer(MemberAttendance)